// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-UgP","content":"styles_content__2amBv","row":"styles_row__2bHRd","footer":"styles_footer__2mgZs","phraseLength":"styles_phraseLength__3xGf1"};